import React from "react"
import { CustomCol } from "../../../spacings"
import ProductGridItem from "../ProductGridItem"
import { PartialGridItemProduct } from "../ProductGridItem/types"

export interface ProductGridWrapperProps {
  products: PartialGridItemProduct[]
  className?: string
  mdColSize?: number
  lgColSize?: number
  xsColSize?: number
  xlColSize?: number
  onClick?: (product: PartialGridItemProduct, index: number) => void
}

const ProductGridWrapper = ({
  products,
  className,
  mdColSize,
  lgColSize,
  xsColSize,
  xlColSize,
  onClick,
}: ProductGridWrapperProps) => {
  return (
    <>
      {products &&
        products.map((product, index) => {
          return (
            <CustomCol
              xl={xlColSize}
              md={mdColSize}
              lg={lgColSize}
              xs={xsColSize}
              key={index}
              className={className}
            >
              <ProductGridItem
                onClick={() => onClick?.(product, index)}
                product={product}
              />
            </CustomCol>
          )
        })}
    </>
  )
}

ProductGridWrapper.defaultProps = {
  lgColSize: 3,
  xsColSize: 6,
}

export default ProductGridWrapper
